import React from "react";
import { useNavigate } from "react-router-dom";
import AppButton from "./AppButton";

interface PageTitleProps {
  title?: string | null;
  customStyles?: string;
  hideBackButton?: boolean;
  children?: JSX.Element | JSX.Element[];
}

const PageTitle = ({
  title,
  customStyles,
  hideBackButton,
  children,
}: PageTitleProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="my-5 d-flex align-items-center justify-content-between position-relative">
          {/* Back button - absoluut gepositioneerd aan de linkerkant */}
          {!hideBackButton && (
              <div className="position-absolute start-0">
                  <AppButton variant="back" onClick={() => navigate(-1)} title={"Back"} />
              </div>
          )}

          {/* Titel in het midden */}
          <h1 className={`mx-auto text-center ${customStyles || ""}`}>
              {title}
          </h1>

          {/* Placeholder rechts voor balans */}
          <div className="invisible position-absolute end-0">
              <AppButton variant="back" title="placeholder" />
          </div>
      </div>

      {children}
    </>
  );
};

export default PageTitle;
